<template>
  <div class="deals-box">
    <menuBox :step="3"></menuBox>
    <div class="title-box">
      <p>Explore The World</p>
      <span>Welcome To India</span>
      <p>Explore and discover the local beauty of India</p>
    </div>
    <div class="weekly-box">
      <div class="title">Explore and discover the local beauty of India</div>
      <div class="text">Welcome to India and experience the customs and customs of India</div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/deals1.png" alt="">
          <div class="mumbai">
            <div class="mumbai-bt">Travel recommendations</div>
            <div class="mumbai-title">Exploring Mumbai City</div>
            <div class="mumbai-text">Explore Mumbai's bustling streets and hidden corners and experience the city's
              history, unique architecture and colorful market life.</div>
            <div class="btn" @click="step">Book Now</div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/deals2.png" alt="">
          <div class="mumbai">
            <div class="mumbai-bt">Travel recommendations</div>
            <div class="mumbai-title">Taj Mahal Day Trip</div>
            <div class="mumbai-text">Admire the majestic view of the world wonder Taj Mahal at sunrise and experience the
              rich cultural and historical atmosphere of this monument that symbolizes love.</div>
            <div class="btn" @click="step">Book Now</div>
          </div>
        </div>
      </div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/deals3.png" alt="">
          <div class="mumbai">
            <div class="mumbai-bt">Travel recommendations</div>
            <div class="mumbai-title">kerala water park</div>
            <div class="mumbai-text">Paddling on the quiet waterways of Kerala, feeling the tranquility of a canoe passing
              under the shade of coconut groves, and experiencing the unique natural and cultural charm of South India.
            </div>
            <div class="btn" @click="step">Book Now</div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/deals4.png" alt="">
          <div class="mumbai">
            <div class="mumbai-bt">Travel recommendations</div>
            <div class="mumbai-title">Goa beach holidays</div>
            <div class="mumbai-text">Immerse yourself in the golden sands and turquoise waters of Goa for a perfect
              holiday of sun, beach and unique Portuguese heritage.</div>
            <div class="btn" @click="step">Book Now</div>
          </div>
        </div>
      </div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/deals5.png" alt="">
          <div class="mumbai">
            <div class="mumbai-bt">Travel recommendations</div>
            <div class="mumbai-title">Rajasthan Royal Heritage</div>
            <div class="mumbai-text">Visit the majestic palaces and ancient forts of Rajasthan and experience the
              luxurious life of the Indian royal family and the rich cultural traditions of the land.</div>
            <div class="btn" @click="step">Book Now</div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/deals6.png" alt="">
          <div class="mumbai">
            <div class="mumbai-bt">Travel recommendations</div>
            <div class="mumbai-title">Himachal Mountain Adventure</div>
            <div class="mumbai-text">Experience the true beauty of nature by trekking on the mountain trails of Himachal
              Pradesh and exploring peaceful villages, verdant forests and spectacular snow-capped mountains.t</div>
            <div class="btn" @click="step">Book Now</div>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "projects" });
    },
  },
};
</script>
<style lang="less" scoped>
.deals-box {
  .title-box {
    background-image: url(../assets/deals.png);
    width: 100%;
    height: 700px;
    background-size: 100% 100%;
    overflow: hidden;
    padding: 226px 360px 0;
    text-align: center;
    box-sizing: border-box;

    p {
      font-size: 20px;
      font-family: ArialMT;
      color: #FFFFFF;
    }

    span {
      margin: 8px 0;
      font-size: 72px;
      font-family: Arial, Arial;
      font-weight: 900;
      color: #FFFFFF;
      line-height: 101px;
    }

  }
}

.weekly-box {
  padding: 100px 304px;

  .title {
    text-align: center;
    margin-bottom: 26px;
    font-size: 32px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #333333;
    line-height: 45px
  }

  .text {
    text-align: center;
    margin-bottom: 40px;
    font-size: 20px;
    font-family: ArialMT;
    color: #999999;
    line-height: 32px;
  }

  .itemBox {
    display: flex;
    margin-bottom: 40px;

    .item {
      width: 50%;
      display: flex;
      margin-right: 40px;

      img {
        width: 291px;
        // height: 388px;
      }

      .mumbai {
        padding: 40px 80px 40px 24px;
        box-sizing: border-box;
        background: #F7F7F7;
        border-radius: 0px 24px 24px 0px;

        .mumbai-bt {
          margin-bottom: 22px;
          font-size: 24px;
          font-family: Arial, Arial;
          font-weight: normal;
          color: #333333;
        }

        .mumbai-title {
          margin-bottom: 12px;
          font-size: 16px;
          font-family: Arial, Arial;
          font-weight: normal;
          color: #333333;
        }

        .mumbai-text {
          margin-bottom: 52px;
          font-size: 16px;
          font-family: ArialMT;
          color: #999999;
          line-height: 32px;
        }

        .btn {
          cursor: pointer;
          display: table;
          padding: 16px 35px;
          background: #00B3C0;
          border-radius: 28px;
          font-size: 16px;
          font-family: ArialMT;
          color: #FFFFFF;
          box-sizing: border-box;
        }
      }
    }

    .item:nth-child(2) {
      margin-right: 0;
    }
  }
}
</style>
